/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateApiKeyRequest
 */
export interface CreateApiKeyRequest {
    /**
     * An optional display name for this key
     * @type {string}
     * @memberof CreateApiKeyRequest
     */
    name?: string | null;
    /**
     * Optional expiration time in ISO-8601 format
     * @type {Date}
     * @memberof CreateApiKeyRequest
     */
    expiresAt?: Date | null;
}

/**
 * Check if a given object implements the CreateApiKeyRequest interface.
 */
export function instanceOfCreateApiKeyRequest(value: object): value is CreateApiKeyRequest {
    return true;
}

export function CreateApiKeyRequestFromJSON(json: any): CreateApiKeyRequest {
    return CreateApiKeyRequestFromJSONTyped(json, false);
}

export function CreateApiKeyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateApiKeyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'expiresAt': json['expires_at'] == null ? undefined : (new Date(json['expires_at'])),
    };
}

export function CreateApiKeyRequestToJSON(json: any): CreateApiKeyRequest {
    return CreateApiKeyRequestToJSONTyped(json, false);
}

export function CreateApiKeyRequestToJSONTyped(value?: CreateApiKeyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'expires_at': value['expiresAt'] == null ? undefined : ((value['expiresAt'] as any).toISOString()),
    };
}

